<template>
  <div id="header" :class="{select: fixedMenu}">
      <div class="header__margin">
          <div class="header__margin__l">
              <div class="catalog__menu">
                <span class="mdi mdi-menu"></span>
                <p>
                    Каталог товаров
                </p>
                <span class="mdi mdi-arrow-down-drop-circle"></span>
                <div 
                    class="menu__catalog__list"
                >   
                    <div 
                        class="menu__view__main"
                        @mouseover="hoverCategoryBlock"
                        @mouseleave="hoverCategoryNone"
                    >
                        <div 
                            class="menu__catalog__list__li"
                            v-for="categoryId in category"
                            :key="categoryId.id"
                            @click="categoryIdOpen(categoryId.id)"
                            @mouseover="hoverGetCategory(categoryId.id)"  
                        >
                            <img :src="'https://ecodom04.com/backend/'+categoryId.img" alt="images">
                            <p>
                                {{categoryId.name}}
                            </p>
                        </div>
                        <div class="menu__subcategory" id="menu__subcategory_scroll">
                            <div class="menu__subcategory__block">
                                <div 
                                    class="menu__subcategory__name"
                                    v-for="subcategoryId in subcategory"
                                    :key="subcategoryId.id"
                                    @click="categoryIdOpen(subcategoryId.id)"
                                    @mouseover="hoverGetSubCategory(subcategoryId.id)"
                                >
                                        <p>
                                            {{subcategoryId.name}}
                                        </p>
                                        <div
                                            class="sub_sub_cat">
                                            <div 
                                                class="sub_sub_cat_sb"
                                                v-for="sub_sub_category in sub_sub_category"
                                                :key="sub_sub_category.id" 
                                                @click="categoryIdOpen(sub_sub_category.id)"
                                            >
                                                <p>
                                                    {{sub_sub_category.name}}
                                                </p>
                                            </div>
                                            
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
          <div class="header__margin__c">
              <Search />
          </div>
          <div class="header__margin__r">
              <div class="header__r__m__user">
                  <router-link to="/favorite">
                        <div class="h__r__m__u__b">
                            <span class="mdi mdi-cards-heart"></span>
                            <div v-if="FAVORITE.length != 0" class="product__length">
                                {{FAVORITE.length}}
                            </div>
                        </div>
                  </router-link>
                  
                  <div v-if="USER.length == 0" class="h__r__m__u__b" @click="openForm">
                        <span class="mdi mdi-account"></span>
                  </div>
                  
                  <router-link to="/profile">
                       <div v-if="USER.length != 0" class="h__r__m__u__b">
                                <span class="mdi mdi-account"></span>
                        </div>
                  </router-link>

                  <router-link to="/basket">
                       <div class="h__r__m__u__b">
                            <span class="mdi mdi-basket-outline"></span>
                            <div v-if="CART.length != 0" class="product__length">
                                {{CART.length}}
                            </div>
                        </div>
                  </router-link>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import Search from '@/components/Search';
import {mapGetters} from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      limitPosition: 85,
      fixedMenu: false,
      category: [],
      subcategory: [],
      subcategoryMain: [],
      sub_sub_category: [],
    };
  },
  components: {
      Search
  },
  methods: {
    openForm() {
        this.$emit('openForm')
        document.querySelector('.modal').style.display = 'block'
    },
    handleScroll() {
      if (window.scrollY > this.limitPosition) {
        this.fixedMenu = true
      } else {
        this.fixedMenu = false
      }
    },
    getCategory() {
            fetch(this.$apiURI + 'public/category/getall')
            .then((res) => {
                res.json().then((data) => {
                    let filterCategory = data.filter((item) => item.parent_id == 0)
                    let filterSubCategory = data.filter((item) => item.parent_id != 0)
                    this.category = filterCategory
                    this.subcategoryMain = filterSubCategory
                });
            })
    },
    hoverGetCategory(id) {
        this.subcategory = this.subcategoryMain.filter(item => item.parent_id == id )
    },
    hoverGetSubCategory(id) {
        this.sub_sub_category = this.subcategoryMain.filter(item => item.parent_id == id )
    },
    hoverCategoryBlock() {
        let mcb = document.querySelector('.menu__subcategory')
        mcb.style.display = 'block'
    },
    hoverCategoryNone() {
        let mcb = document.querySelector('.menu__subcategory')
        mcb.style.display = 'none'
    },
    categoryIdOpen(id) {
        this.$router.push({ name: 'FilterCategory', params: { id: id }})
        this.$upd.$emit('updatefiltercategory')
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getCategory()  
  },
  computed: {
      ...mapGetters(['CART', 'FAVORITE', 'USER'])
  }
}
</script>
<style scoped lang="less">
.select {
    position: fixed;
    top: 0;
    z-index: 999;
}
#header {
    width: 100%;
    background: #680;
    .header__margin {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .header__margin__l {
            width: 20%;
            display: flex;
            justify-content: flex-start;
            .catalog__menu {
                position: relative;
                display: flex;
                justify-content: flex-start;
                z-index: 999;
                cursor: pointer;
                background: #76941a;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-left: 10px;
                padding-right: 10px;
                &:hover{
                    background:#557102;
                }
                &:hover .menu__catalog__list{
                    display: block;
                }
                p {
                    font-size: 20px;
                    margin-left: 10px;
                    margin-right: 10px;
                    color: #fff;
                }
                span {
                    color: #fff;
                    font-size: 20px;
                }
                .menu__catalog__list {
                    display: none;
                    width: 100%;
                    position: absolute;
                    top: 54px;
                    left: 0;
                    background: #fff;
                    z-index: 999;
                    box-shadow: 3px 2px 5px 0px rgba(0,0,0,0.42);
                    .menu__catalog__list__li {
                        width: 100%;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        background: #f5f5f5;
                        padding-left: 10px;
                        display: flex;
                        position: relative;
                        justify-content: flex-start;
                        margin-bottom: 2px;
                        &:hover {
                            background: #ccc;
                            cursor: pointer;
                        }
                        img {
                            width: 23px;
                            height: 20px;
                            border-radius: 50%;
                        }
                        p {
                            font-size: 14px;
                            color: #000;
                            font-weight: bold;
                            margin-left: 7px;
                        }
                    }
                    #menu__subcategory_scroll::-webkit-scrollbar-track
                    {
                        border-radius: 5px;
                        background-color: #fff;
                    }

                    #menu__subcategory_scroll::-webkit-scrollbar
                    {
                        width: 10px;
                    }

                    #menu__subcategory_scroll::-webkit-scrollbar-thumb
                    {
                        border-radius: 5px;
                        background-color: #680;
                    }
                    .menu__subcategory {
                        position: absolute;
                        right: -983px;
                        display: none;
                        height: 200px;
                        top: 0;
                        width: 983px;
                        background: #fff;
                        overflow-y: scroll;
                        box-shadow: 3px 2px 5px 0px rgba(0,0,0,0.42);
                        .menu__subcategory__block {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            align-items: flex-start;
                            flex-wrap: wrap;
                            .menu__subcategory__name {
                                width: 32.7%;
                                background: #668800;
                                margin: 3px;
                                cursor: pointer;
                                position: relative;
                                // overflow: hidden;
                                &:hover .sub_sub_cat {
                                    background: #668800;
                                    display: block;
                                }
                                p {
                                    font-size: 15px;
                                    margin-top: 5px;
                                    margin-bottom: 5px;
                                }
                                .sub_sub_cat {
                                    width: 100%;
                                    position: absolute;
                                    top: 28px;
                                    z-index: 999999;
                                    display: none;
                                    .sub_sub_cat_sb {
                                        width: 100%;
                                        border-top: 1px solid #fff;
                                        overflow: hidden;
                                        padding-top: 5px;
                                        padding-bottom: 5px;
                                        &:hover {
                                            background: #82a90f;
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            
        }
        .header__margin__c {
            width: 60%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
         .header__margin__r {
            width: 20%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .header__r__m__user {
                display: flex;
                justify-content: flex-end;
                .h__r__m__u__b {
                    width: 50px;
                    height: 50px;
                    background: #76941a;
                    display: flex;
                    justify-content: center;
                    position: relative;
                    align-items: center;
                    margin: 1px;
                    .product__length {
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        background: red;
                        color: #fff;
                        font-size: 12px;
                        font-weight: bold;
                        position: absolute;
                        top: -2px;
                        text-align: center;
                        line-height: 24px;
                        right: -3px;  
                    }
                    &:hover {
                        opacity: 0.7;
                    }
                    cursor: pointer;
                    span {
                        color: #fff;
                        font-size: 30px;
                    }
                }
            }
        }
    }
}
</style>
